module.exports = __webpack_public_path__ + "static/media/pdp_boat_mid-banner.aa4052d7.png";